module.exports = __webpack_public_path__ + "assets/muqinjie.406463f2.svg";